// Stable per-browser identity for multi-device admin push notifications.
const STORAGE_KEY = 'revvit_admin_device_id'

const generateUuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID()
  // randomUUID needs a secure context; fall back to getRandomValues
  const bytes = window.crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
    .slice(6, 8)
    .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`
}

// Returns the stored deviceId, or null if this browser never registered.
export const getDeviceId = () => {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export const getOrCreateDeviceId = () => {
  const existing = getDeviceId()
  if (existing) return existing

  const deviceId = `admin-web-${generateUuid()}`
  try {
    localStorage.setItem(STORAGE_KEY, deviceId)
  } catch {
    // Storage blocked (private mode): the id lives for this page load only
  }
  return deviceId
}

export const getBrowserMetadata = () => {
  const userAgent = navigator.userAgent || ''
  let browserName = 'Browser'

  // Order matters: Brave sends Chrome's UA, and Edge/Opera/Chrome UAs also
  // contain "Safari"
  if (navigator.brave) browserName = 'Brave'
  else if (userAgent.includes('Firefox')) browserName = 'Firefox'
  else if (userAgent.includes('Edg')) browserName = 'Edge'
  else if (userAgent.includes('OPR')) browserName = 'Opera'
  else if (userAgent.includes('Chrome')) browserName = 'Chrome'
  else if (userAgent.includes('Safari')) browserName = 'Safari'

  const os =
    navigator.userAgentData?.platform || navigator.platform || 'Unknown OS'

  return {
    deviceName: `${browserName} on ${os}`,
    deviceModel: browserName,
    osVersion: os,
  }
}
